<template>
  <div id="app" style="overflow-x: auto; min-width: 1200px">
    <pc-header class="header"></pc-header>

    <div class="flex">
      <pc-menu class="menu"></pc-menu>
      <router-view class="app" :key="$route.fullPath" />
    </div>

    <!-- <app-footer-nav></app-footer-nav> -->
    <!-- <div class="specailDia">
			<el-dialog
				:visible.sync="dialogVisible"
				:close-on-click-modal="false"
				:show-close="false"
				width="800px"
			>
				<div class="message">
					<p class="padding">
						敬请注意，本保时捷问卷调查沟通的所有信息均属于【内部】信息，应依据《经销商和服务协议》予以严格保密。任何未经授权的披露或传递，无论出于故意或过失，可能会使您和/或您所在的机构承担法律责任。使用本保时捷问卷调查表示您已同意并承诺遵守保密义务。
					</p>
					<p
						style="white-space:normal;word-break: break-word; width:760px;"
					>
						Please note all information communicated in the Porsche
						Bytes are internal information, which shall be treated
						in confidence in accordance with the Dealer and Services
						Agreement. Any unauthorized disclosure or distribution,
						no matter by intention or negligence, may expose you
						and/or your entity to legal liabilities. By using the
						Porsche Bytes, you agree and undertake that you will
						observe the confidentiality obligations.
					</p>
					<p class="padding">
						遵守反垄断法对保时捷来说至关重要。因此，保时捷期望保时捷的经销商伙伴及其员工不要将任何的保时捷沟通平台用作实施可能违反反垄断法的行为的平台，保时捷自己也将以身作则。就此而言，我们不会容忍反竞争协议的出现，亦不会容忍交流竞争相关信息的做法
						–
						无论是在制造商或进口商层面还是在零售层面。我们请您遵守这些原则以保护您自身利益。非常感谢！
					</p>
					<p
						style="white-space:normal;word-break: break-word; width:760px;"
					>
						Compliance with antitrust law is of crucial importance
						for Porsche. Porsche therefore expects of our dealers
						and their employees that they do not use any of
						Porsche's communication channels as forum for possible
						conduct in breach of antitrust law, just as Porsche
						itself would not use them in this way. In this
						connection, we tolerate neither anticompetitive
						agreements nor the exchange of competitively relevant
						information – irrespective of whether on the
						manufacturer, importer or retail level. We would like to
						ask you in your own interest to comply with these
						principles. Thank you very much.
					</p>
					<p class="juese">您当前的角色属于 【{{ h5Role }}】</p>
					<p class="special">
						【保时捷中心那些事】 和 【培训中心那些事】
						为互动区，可供所有的用户提问与回答
					</p>
					<div class="bo" style="color:#336699">
						<p>百辞 拥有以下角色：</p>
						<p>游客：拥有互动区的提问与回答权限</p>
						<p>经销商：拥有所有版块的提问与回答权限</p>
						<p>
							辅导员：拥有所有版块的提问与回答权限，并能协助培训中心老师回答问题
						</p>
					</div>
					<el-button
						:disabled="disabled"
						@click="read"
						class="sure_btn"
						>我已阅读并确认相关条例 {{ content }}</el-button
					>
				</div>
			</el-dialog>
		</div> -->
  </div>
</template>

<script>
// import h5PowerApi from '@/app/script/power.js'
import Watermark from "@/pc/assets/js/watermark";

export default {
  name: "pc",
  data() {
    return {
      dialogVisible: false,
      info: {},
      disabled: true,
      content: 10,
      totalTime: 10,
      h5Role: "",
    };
  },
  created() {
    window.thisPC = this;
    document.querySelector("html").style.fontSize = 100 + "px";
  },
  mounted() {
    this.h5Ajax("get", "$/user/info", {}, true)
      .then((res) => {
        var roles = {
          vacationer: "游客",
          dealer: "经销商",
          counselor: "辅导员",
          teacher: "培训中心老师",
          administrator: "超级管理员",
        };
        this.h5Role = roles[res.roles];
        let number = res.staffNo;
        this.info = res;
        Watermark.set(number);
        if (this.info.declaration == 0) {
          this.dialogVisible = true;
        } else {
          this.dialogVisible = false;
        }
      })
      .catch((err) => {
        console.error("err:" + err);
      });

    this.content = this.totalTime + "s"; //这里解决60秒不见了的问题

    let clock = window.setInterval(() => {
      this.totalTime--;

      this.content = this.totalTime + "s";

      if (this.totalTime < 0) {
        //当倒计时小于0时清除定时器

        window.clearInterval(clock);

        this.content = "";

        this.disabled = false;

        this.totalTime = 60;
      }
    }, 1000);
  },
  methods: {
    read() {
      this.h5Ajax("post", "$/user/declaration", {}, true)
        .then((res) => {
          this.dialogVisible = false;
        })
        .catch((err) => {
          console.error("err:" + err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.specailDia {
  /deep/ .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
  }
}

.message {
  font-size: 16px;
  // font-weight: bold;
  color: #333;
  position: relative;
  .bo {
    p {
      line-height: 1.3;
    }
  }
}
.padding {
  padding: 20px 0;
  text-align: justify;
}
.juese {
  border-top: 1px solid #d0d0d0;
  padding-top: 20px;
  color: #336699;
}
.special {
  padding: 20px 0;
  color: #336699;
}
.sure_btn {
  color: #fff;
  background: #e80505;
  text-align: center;
  height: 40px;
  width: 200px;
  font-weight: 200;
  cursor: pointer;
  padding: 0 !important;
  display: block !important;
  position: absolute;
  right: 0;
  bottom: 0;
}
.el-button.is-disabled {
  background-color: #999 !important;
  color: #fff !important;
}
.max {
}
.header {
  position: fixed;
  width: 100%;
  height: 70px;
  left: 0;
  z-index: 999;
}
.flex {
  display: flex;
  min-height: 100%;
  padding-top: 70px;
  position: relative;

  .menu {
    background: #4a4e51;
    width: 260px;
    height: 100%;
    position: fixed;
    left: 0;
    top: 70px;
    z-index: 2;
  }

  .app {
    position: relative;
    padding: 16px 16px 16px 276px;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pc/index.vue